import { useCookies } from "react-cookie";
import { useAuthStoreV1 } from "@/stores/authStore_v1";
import env from "@/config/env";

export function org360ApiBase(): string {
  return `${env.API_URL.replace(/\/+$/, "")}/proxy/graph-view`;
}

export function useOrg360Api() {
  const [cookies] = useCookies(["auth_token"]);
  const storeToken = useAuthStoreV1((state) => state.token);
  const user = useAuthStoreV1((state) => state.user);
  const selectedOrg = useAuthStoreV1((state) => state.selectedOrg);

  const token = cookies.auth_token || storeToken;

  async function getJson<T>(path: string, params?: Record<string, string | undefined>): Promise<T | null> {
    const url = new URL(`${org360ApiBase()}${path}`);
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined) url.searchParams.set(k, v);
      });
    }
    const headers: Record<string, string> = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    if (user?.id) headers["X-User-ID"] = user.id;
    if (selectedOrg?.id) headers["X-Organization-ID"] = selectedOrg.id;

    const res = await fetch(url.toString(), { headers });
    if (res.status === 304) return null;
    if (!res.ok) throw new Error(`Org360 API ${res.status}: ${path}`);
    return res.json() as Promise<T>;
  }

  return {
    getJson,
    orgId: selectedOrg?.id ?? "",
    userId: user?.id ?? "",
  };
}
